import React from "react";
import { GridColDef } from "@mui/x-data-grid";

import { TableCell } from "@shared/components";
import { DeleteButton, EditButton } from "@refinedev/mui";

interface AgreementAppColumnsProps {
  onRefetch: () => void;
  translate: (key: string) => string;
}

const statusNames: any = {
  created: "Criado",
  in_processing: "Build Criada",
  published: "Publicado",
};

export const useAgreementAppsListColumns = ({
  translate,
  onRefetch,
}: AgreementAppColumnsProps): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "agreement_name",
        headerName: translate("v1/agreement_app_admin.fields.agreement"),
        width: 200,
      },
      {
        field: "name",
        headerName: translate("v1/agreement_app_admin.fields.name"),
        width: 200,
      },
      {
        field: "slug",
        headerName: translate("v1/agreement_app_admin.fields.slug"),
        width: 200,
      },
      {
        field: "bundleIdentifier",
        headerName: translate("v1/agreement_app_admin.fields.bundleIdentifier"),
        width: 200,
      },
      {
        field: "status",
        headerName: translate("v1/agreement_app_admin.fields.status"),
        minWidth: 150,
        renderCell: ({ value }) => statusNames[value],
      },
      {
        field: "created_at",
        headerName: translate("v1/agreement_app_admin.fields.created_at"),
        minWidth: 180,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date value={value} align="center" />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton hideText recordItemId={row.id} />
            {/* <DeleteButton
              hideText
              recordItemId={row.id}
              resource="v1/agreement_app_admin"
              onSuccess={onRefetch}
            /> */}
          </TableCell.Container>
        ),
      },
    ],
    [translate]
  );
};
